/**
 * Created by OLD on 20/11/2015.
 */
define('removeBackgroundRouter',[
    'require',
    'exports',
    'module',
    'logger',
    'marionette',
    'app',
    'itemPagesNameMixin'
], function(
    require,
    exports,
    module,
    Logger,
    Marionette,
    App,
    ItemPagesNameMixin
) {
  'use strict';

  var RemoveBackgroundRouter = Marionette.AppRouter.extend({
    appRoutes: {
      'remove_background': 'showRemoveBackground',
      'remove_background/:secId' : 'showRemoveBackground'
    }
  });

  var API = {
    showRemoveBackground: function(secId) {
      require([
        'removeBackgroundShowController',
        'contentShowController',
        'rBticketsController'
      ], function(ShowController, ContentShowController, TicketsController) {
        ContentShowController.showContent().done(function() {
          App.startSubModule('removeBackgroundMain');
          if (!secId) {
            ShowController.showRemoveBackground();
          } else {
            TicketsController.showTickets(secId);
          }
          App.execute('set:active:nav:item', ItemPagesNameMixin.GRAPHICALREQUESTS_REMOVEBACKGROUND);
        });
      });
    }
  };

  App.on('remove_background:show', function(secId) {
    if (secId) {
      App.navigate('remove_background/' + secId);
    } else {
      App.navigate('remove_background');
    }
    API.showRemoveBackground(secId);
  });

  App.on('before:start', function() {
    new  RemoveBackgroundRouter({
      controller: API
    });
  });

  module.exports = RemoveBackgroundRouter;
});
